module.exports = __webpack_public_path__ + "img/Bank Victoria.baec2617.png";